import React from 'react';
import {
  FormProvider,
  useForm,
} from 'react-hook-form';
import dayjs from 'utils/dayjs';
import {
  formatISODateTime,
} from 'utils/date';
import {
  EOBExtractionResponseDTO,
  EOBWithInsurancePaymentRequestDTO,
  EOBWithInsurancePaymentResponseDTO,
} from 'dtos';
import {
  LocalMediaFile,
} from 'pages/Dashboard/pages/Billing/types';
import WizardProvider from 'pages/Dashboard/pages/Billing/Payments/EOBDialog/wizardContext';
import {
  usePrompt,
} from 'core/hooks';
import {
  Payer,
} from 'pages/Dashboard/types/insurance';
import {
  PatientCompact,
} from 'pages/Dashboard/pages/Encounters/types/patient';

export type EOBDialogParams = {
  eobNumber?: string;
  defaultPatient?: PatientCompact;
  defaultStartDate?: string;
  parsedEOBData?: EOBWithInsurancePaymentResponseDTO;
  parsedEOBFile?: File;
  parsedEOBErrors?: Omit<EOBExtractionResponseDTO, 'eobWithInsurancePayment'>;
  eobExtractionJobId?: number;
};

type Props = EOBDialogParams & {
  onClose: () => void;
};

export type EOBForm = EOBWithInsurancePaymentRequestDTO & {
  eobDoc?: LocalMediaFile | null;
  payer?: Payer | null;
};

export default function EOBDialog({
  eobNumber: defaultEOBNumber = '',
  onClose,
  defaultPatient,
  defaultStartDate,
  parsedEOBData,
  parsedEOBFile,
  parsedEOBErrors,
  eobExtractionJobId,
}: Props) {
  const form = useForm<EOBForm>({
    mode: 'all',
    defaultValues: {
      eob: { eobNumber: defaultEOBNumber },
      payer: null,
      insurancePayment: {
        paymentDate: formatISODateTime(dayjs(), false),
        paymentMethod: {
          paymentAmount: 0,
          transactionIdentifier: null,
        },
      },
    },
  });
  const { formState: { isDirty } } = form;

  usePrompt(isDirty);

  return (
    <FormProvider {...form}>
      <WizardProvider
        defaultPatient={defaultPatient}
        defaultStartDate={defaultStartDate}
        parsedEOBData={parsedEOBData}
        parsedEOBFile={parsedEOBFile}
        parsedEOBErrors={parsedEOBErrors}
        eobExtractionJobId={eobExtractionJobId}
        onClose={onClose}
      />
    </FormProvider>
  );
}
